<template>
    <div class="switch-btn-box">
        <!--收起按钮-->
        <!-- <div class="sider-switch-btn left-[716px] top-[60px]" v-if="sidebarShow"  @click="hideSiderbar">
            <div class="close-btn"></div>
        </div> -->
        <!--展开按钮-->
        <div class="sider-switch-btn left-[358px] top-[248px]" @click="showSiderbar">
            <div class="open-btn"></div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["sidebarShow"],
  data() {
    return {

    }
  },
  mounted() {
    
  },
  methods: {
      //隐藏侧边栏
    //   hideSiderbar() {
    //       this.$emit("closeSiderbar");
    //   },
      //展示侧边栏
      showSiderbar() {
          this.$emit("openSiderbar");  
      },
  },
};
</script>

<style lang="scss" scoped>
.switch-btn-box{
    .sider-switch-btn{
          @apply max-sm:hidden w-10 h-10 bg-white rounded-[10px] rounded-l-none flex flex-row justify-center items-center cursor-pointer border-[1px] border-l-0 border-[#C2C4CB] fixed z-10;
        .close-btn{
            @apply w-[9px] h-4;
            background: url(@/assets/icon_close_sidebar.png) no-repeat;
            background-size: 100% auto;
        }
        .open-btn{
            @apply w-5 h-[15px];
            background: url(@/assets/icon_open_sidebar.png) no-repeat;
            background-size: 100% auto;
        }
    }
}
</style>